function runAt(selector, callback) {
  const interval = setInterval(() => {
    const el = document.querySelector(selector);
    if (el && el.children.length) {
      clearInterval(interval);
      callback();
    }
  }, 100);
}

function getSelectors() {
  const cartDrawer = document.querySelector("#CartDrawer");
  return {
    cartDrawer: cartDrawer,
    bestsellerProducts: cartDrawer
      ? cartDrawer.querySelectorAll(".bestseller-item")
      : [],
    bestsellerPopups: cartDrawer
      ? cartDrawer.querySelectorAll(".bestseller-popup")
      : [],
  };
}

function handleButtonClick(button, callback) {
  if (!button || button.dataset.listenerAttached) return;
  button.dataset.listenerAttached = "true";
  button.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (typeof callback === "function") callback(e);
  });
}

function formCartAPI(form) {
  const formData = new FormData(form);

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    body: formData,
  })
    .then((response) => response.json())
    .then((data) => {
      form.closest('.bestseller-popup')?.classList.remove("active");
      document.body.classList.remove("js-bestseller_overlay");

      // Udate Cart Drawer
      document.dispatchEvent(
        new CustomEvent("ajaxProduct:added", {
          bubbles: true,
        })
      );
    })
    .catch((error) => {
      console.error("Error adding to cart:", error);
    });
}

function globalFunction() {
  const selectors = getSelectors();

  // "HINZUFÜGEN" button logic
  selectors.bestsellerProducts.forEach((product) => {
    const button = product.querySelector('button[type="button"]');
    const popupId = product.dataset.model;
    const popup = document.getElementById(popupId);

    handleButtonClick(button, () => {
      selectors.bestsellerPopups.forEach((p) => p.classList.remove("active"));
      if (popup) {
        popup.classList.add("active");
        document.body.classList.add("js-bestseller_overlay");
      }
    });
  });

  // Popup close + form submit
  selectors.bestsellerPopups.forEach((popup) => {
    const closeBtn = popup.querySelector("button.popup-close");
    const form = popup.querySelector('form[action="/cart/add"]');
    const swatches = popup.querySelectorAll('.color--swatch');

    handleButtonClick(closeBtn, () => {
      popup.classList.remove("active");
      document.body.classList.remove("js-bestseller_overlay");
    });

    if (form && !form.dataset.listenerAttached) {
      form.dataset.listenerAttached = "true";
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        e.stopPropagation();
        formCartAPI(form);
      });
    }

    // ✅ Attach click listeners (avoid re-selecting)
    swatches.forEach((swatch) => {
      handleButtonClick(swatch, () => {
        if (swatch.classList.contains("selected")) return;
        swatches.forEach((s) => s.classList.remove("selected"));
        swatch.classList.add("selected");
        
        const swatchJSON = JSON.parse(swatch.dataset.product);
        renderPopupData(popup, swatchJSON);

        // Global Color Change
        const colorData = swatch.dataset.color;
        popup.style.setProperty("--button-color", colorData, "important");

        const colorType = ['#d2eeff', '#eeddb7', '#ffdcf1', '#c5c5c5', '#95ceff', '#fff4de', '#d3c3e9', '#fbb4dd', '#bbf1f6', '#ffd600', '#eeeeee'];

        if (colorType.includes(colorData.toLowerCase())) {
           popup.style.setProperty("--text-color", "#000", "important");
        } else {
          popup.style.setProperty("--text-color", "#fff", "important");
        }
      });
    });

    // ✅ Log initially selected swatch, if any (in one line)
    const selected = [...swatches].find(s => s.classList.contains("selected"));
    if (selected) {
      const parsedData = JSON.parse(selected.dataset.product);
      renderPopupData(popup, parsedData);

    // Global Color Change
      const colorData = selected.dataset.color;
      popup.style.setProperty("--button-color", colorData, "important");

      const colorType = ['#d2eeff', '#eeddb7', '#ffdcf1', '#c5c5c5', '#95ceff', '#fff4de', '#d3c3e9', '#fbb4dd', '#bbf1f6', '#ffd600', '#eeeeee'];

      if (colorType.includes(colorData.toLowerCase())) {
          popup.style.setProperty("--text-color", "#000", "important");
      } else {
        popup.style.setProperty("--text-color", "#fff", "important");
      }
    }

  });
}

function renderPopupData(popupEl, productData) {
  if (!popupEl || typeof productData !== 'object') return;

  const productImage = productData.featured_image
    ? `${productData.featured_image}`
    : "";
  const productTitle = productData.title || "No Title";
  const productPrice = productData.price
    ? theme.Currency.formatMoney(productData.price, theme.settings.moneyFormat)
    : "No Price";
    const productCPrice = productData.compare_at_price
    ? theme.Currency.formatMoney(productData.compare_at_price, theme.settings.moneyFormat)
    : "No Price";
  const productVariants = productData.variants || [];

  // Find DOM elements inside the popup
  const itemImage = popupEl.querySelector(".product_media");
  const itemTitle = popupEl.querySelector(".b_title");
  const itemPrice = popupEl.querySelector(".b_price");
  const itemCPrice = popupEl.querySelector(".c_price");
  const itemVariants = popupEl.querySelector(".size-swatch_grid");
  const variantInput = popupEl.querySelector('input[name="id"]');

  // ✅ Update image src + srcset
  if (itemImage && productImage) {
    itemImage.src = `${productImage}&width=700`;

    itemImage.srcset = `
      ${productImage}&width=352 352w,
      ${productImage}&width=832 832w,
      ${productImage}&width=1200 1200w
    `;
  }

  if(itemCPrice)
  {
  if(productData.compare_at_price > productData.price )
  {
  itemCPrice.style.display="flex";
  }
  else
  {
  itemCPrice.style.display="none";
  }
}
  if (itemTitle) itemTitle.textContent = productTitle;
  if (itemPrice) itemPrice.textContent = productPrice;
  if (itemCPrice) itemCPrice.textContent = productCPrice;

  // ✅ Render size swatches with availability
  if (itemVariants && Array.isArray(productVariants)) {
    itemVariants.innerHTML = variantOptions(productVariants);

    let lastSelectedValue = popupEl.dataset.selected || null;
    let selectedVariant = null;

    if (lastSelectedValue) {
      selectedVariant = productVariants.find(v => v.title === lastSelectedValue && v.available);
    }

    if (!selectedVariant) {
      selectedVariant = productVariants.find(v => v.available);
    }

    if (selectedVariant) {
      const btnToSelect = itemVariants.querySelector(`.size--swatch[value="${selectedVariant.title}"]`);
      if (btnToSelect) btnToSelect.classList.add("selected");

      const variantInputEl = popupEl.querySelector('input[name="id"]');
      if (variantInputEl) {
        variantInputEl.value = selectedVariant.id;
      }

      popupEl.dataset.selected = selectedVariant.title;
    }

    // ✅ Add click functionality
    itemVariants.querySelectorAll(".size--swatch").forEach((btn) => {
      delete btn.dataset.listenerAttached;

      handleButtonClick(btn, () => {
        if (btn.classList.contains("selected")) return;

        itemVariants.querySelectorAll(".size--swatch").forEach((b) =>
          b.classList.remove("selected")
        );

        btn.classList.add("selected");

        const selectedId = btn.dataset.variantId;
        const selectedValue = btn.getAttribute("value");

        popupEl.dataset.selected = selectedValue;

        const variantInputEl = popupEl.querySelector('input[name="id"]');
        if (variantInputEl) {
          variantInputEl.value = selectedId;
          // console.log("✅ Variant input updated:", selectedId);
        }
      });
    });
  }
}

function variantOptions(variants) {
    if (!variants.length) return "<p>No variants available</p>";

    let variantHTML = "";
    variants.forEach((variant) => {
      variantHTML += `
      <button class="size--swatch" value="${variant.title}" data-variant-id="${variant.id}" ${
        variant.available ? "" : "disabled"
      }>
        ${variant.title}
      </button>
    `;
    });

    return variantHTML;
}


runAt("#CartDrawer .cart_bestseller-wrapper", globalFunction);

document.addEventListener("cart:updated", () => {
  runAt("#CartDrawer .cart_bestseller-wrapper", globalFunction);
});

// Monkey-patch fetch (optional — only if theme doesn’t dispatch "cart:updated" itself)
const originalFetch = window.fetch;
window.fetch = async (...args) => {
  const response = await originalFetch(...args);
  if (args[0].includes("/cart")) {
    document.dispatchEvent(new CustomEvent("cart:updated"));
  }
  return response;
};
